import styles from '../../blog/blog.module.css';
export function MediaInsta() {
    return <section className={`${styles.instgram_post} text-center`}>
        <h2 className={`${styles.sectionHeading} sectionHeading`}>@nirvasa_official</h2>
        <p>India&apos;s 1st Multispeciality Digital Health Clinic</p>
        <div className="container">
            <div className={`${styles.instgram_feed_box} pt30`}>
                <script src="https://static.elfsight.com/platform/platform.js" data-use-service-core defer></script>
                <div className="elfsight-app-80e539ca-a1f0-419b-9954-3ecc53b435b0"></div>
            </div>
        </div>
    </section>
}